import { PublicKey } from '@solana/web3.js';
import { getBytesCodec, getStructCodec, getU32Codec } from '@solana/codecs';
var tokenGroupMemberCodec = getStructCodec([['mint', getBytesCodec({
  size: 32
})], ['group', getBytesCodec({
  size: 32
})], ['memberNumber', getU32Codec()]]);
export var TOKEN_GROUP_MEMBER_SIZE = tokenGroupMemberCodec.fixedSize; // Pack TokenGroupMember into byte slab

export function packTokenGroupMember(member) {
  return tokenGroupMemberCodec.encode({
    mint: member.mint.toBuffer(),
    group: member.group.toBuffer(),
    memberNumber: member.memberNumber
  });
} // unpack byte slab into TokenGroupMember

export function unpackTokenGroupMember(buffer) {
  var data = tokenGroupMemberCodec.decode(buffer);
  return {
    mint: new PublicKey(data.mint),
    group: new PublicKey(data.group),
    memberNumber: data.memberNumber
  };
}